import React from 'react'
import { cn } from './cn'

const variants = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
  ghost:
    'inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium text-secondary-600 transition-colors hover:bg-secondary-100 dark:text-secondary-300 dark:hover:bg-secondary-800',
  link: 'inline-flex items-center text-sm font-medium text-primary-600 hover:text-primary-700 dark:text-primary-400',
}

const sizes = {
  sm: 'px-3 py-1.5 text-xs',
  md: '',
  lg: 'px-5 py-2.5 text-base',
}

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  type = 'button',
  children,
  ...props
}) {
  return (
    <button
      type={type}
      className={cn(variants[variant], size !== 'md' && sizes[size], className)}
      {...props}
    >
      {children}
    </button>
  )
}
